export { default as List } from 'accounts/containers/AccountsListContainer';
export { default as Form } from 'accounts/containers/AccountsFormContainer';



// WEBPACK FOOTER //
// src/modules/secured/modules/accounts/containers/index.js